import { Routes } from '@angular/router';
import {
  Login,
  authGuard,
  antiAuthGuard,
  ImprintComponent,
  TermsOfUseComponent,
  ServiceConditions,
  DataProtectionComponent,
  NoteForUsResidentsComponent,
  CookieConsentComponent,
  AdminApproval,
  ForgetPasswordEmail,
} from '@lp-ui-lib';
import { SettingsComponent } from '@lp-ui-lib';
import { Signup } from '@lp-ui-lib';
import { SettingsSubpageComponent } from '@lp-ui-lib';
import { HomepageComponent } from './features/homepage/homepage';
import { PlantOverviewComponent } from './features/plant-overview/plant-overview';
import { NotificationsListComponent } from './features/notifications/notifications-list/notifications-list';
import { AssetOverview } from './features/asset-overview/asset-overview';
import { SensorHealthPage } from './features/asset-overview/sensor-health-page/sensor-health-page';
import { DisabledAssetsComponent } from './features/disabled-assets/disabled-assets';
import { AssetSensorHistory } from './features/asset-overview/telemetry-page/asset-sensor-history/asset-sensor-history';
import { TelemetryPage } from './features/asset-overview/telemetry-page/telemetry-page';

export const routes: Routes = [
  {
    path: 'login/forgotpw/:mail',
    component: Login,
    canActivate: [antiAuthGuard],
    data: { animation: 'Login' },
  },
  {
    path: 'login/refauth/:token/:args',
    component: Login,
    canActivate: [antiAuthGuard],
    data: { animation: 'Login' },
  },
  {
    path: 'login/refauth/:token',
    component: Login,
    canActivate: [antiAuthGuard],
    data: { animation: 'Login' },
  },
  { path: 'login/us', redirectTo: '/login?country=us' },
  {
    path: 'login',
    component: Login,
    canActivate: [antiAuthGuard],
  },
  {
    path: 'login/:key',
    component: Login,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'Login',
    },
  },
  {
    path: 'signup',
    component: Signup,
    canActivate: [antiAuthGuard],
    data: {},
  },
  {
    path: 'changepw/:token',
    component: ForgetPasswordEmail,
    canActivate: [antiAuthGuard],
    data: { animation: 'Login' },
  },
  {
    path: 'admin/approve-user/:token',
    component: AdminApproval,
    canActivate: [antiAuthGuard],
    data: {},
  },
  {
    path: 'home/:tab/:id',
    component: HomepageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'Homepage',
      tabIndex: 0,
      backBtn: false,
      routeReuse: true,
      reuseID: -1,
    },
  },
  {
    path: 'service-conditions-updated',
    component: ServiceConditions,
    data: {
      tabIndex: 0,
      backBtn: true,
      appHeader: false,
    },
  },
  {
    path: 'home/:tab',
    component: HomepageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'Homepage',
      tabIndex: 0,
      backBtn: false,
      routeReuse: true,
      reuseID: -1,
    },
  },
  {
    path: 'home',
    component: HomepageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'Homepage',
      tabIndex: 0,
      backBtn: false,
      routeReuse: true,
      reuseID: -1,
    },
  },
  {
    path: 'notifications',
    component: NotificationsListComponent,
    data: { animation: 'Notifications', tabIndex: 1, backBtn: false },
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [authGuard],
    data: { animation: 'Settings', tabIndex: 2, backBtn: false },
  },
  {
    path: 'settings/profile',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/change-password',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/language',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/metric',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/appearance',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/notifications',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/technical_documents',
    component: SettingsSubpageComponent,
    // canActivate: [authGuard],
    data: {
      animation: 'SettingsSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/notifications/flange',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSubSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/notifications/pipe',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSubSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/notifications/steamtrap',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSubSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/notifications/rotating',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSubSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/note-for-us-residents',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'note-for-us-residents',
    component: NoteForUsResidentsComponent,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'LegalDocuments',
      tabIndex: 0,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'cookie-consent',
    component: CookieConsentComponent,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'LegalDocuments',
      tabIndex: 0,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/data-protection',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'data-protection',
    component: DataProtectionComponent,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'LegalDocuments',
      tabIndex: 0,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'us/data-protection',
    component: DataProtectionComponent,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'LegalDocuments',
      tabIndex: 0,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/service-conditions',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/technical_documents/:page',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSubSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/help',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/help/about',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSubSub', tabIndex: 2, backBtn: true },
  },

  {
    path: 'settings/imprint',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSub',
      tabIndex: 0,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/help/faq',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSubSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/terms-of-use',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: {
      animation: 'SettingsSub',
      tabIndex: 2,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'settings/terms',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/terms/termsofservice',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSubSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'settings/terms/privacypolicy',
    component: SettingsSubpageComponent,
    canActivate: [authGuard],
    data: { animation: 'SettingsSubSub', tabIndex: 2, backBtn: true },
  },
  {
    path: 'legal-imprint',
    component: ImprintComponent,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'LegalDocuments',
      tabIndex: 0,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'imprint',
    component: ImprintComponent,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'LegalDocuments',
    },
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseComponent,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'LegalDocuments',
      tabIndex: 0,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'service-conditions',
    component: ServiceConditions,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'LegalDocuments',
      tabIndex: 0,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'us/terms-of-use',
    component: TermsOfUseComponent,
    canActivate: [antiAuthGuard],
    data: {
      animation: 'LegalDocuments',
      tabIndex: 0,
      backBtn: true,
      appHeader: true,
    },
  },
  {
    path: 'sensor-history/:id/:sensorid/:measurementid',
    component: AssetSensorHistory,
    canActivate: [authGuard],
    data: { animation: 'SensorHistory', tabIndex: 0, backBtn: true },
  },
  {
    path: 'plant/:id',
    component: PlantOverviewComponent,
    canActivate: [authGuard],
    data: { animation: 'PlantOverview', tabIndex: 0, backBtn: true },
  },
  {
    path: 'asset/:id/:sensorid',
    component: AssetOverview,
    canActivate: [authGuard],
    data: {
      animation: 'AssetOverview',
      tabIndex: 0,
      backBtn: true,
      routeReuse: true,
      reuseID: ':id',
    },
  },
  {
    path: 'sensor-health/:id',
    component: SensorHealthPage,
    canActivate: [authGuard],
    data: { animation: 'SensorHealth', tabIndex: 0, backBtn: true },
  },
  {
    path: 'sensor-value/:id/:sensorid/:measurementid',
    component: TelemetryPage,
    canActivate: [authGuard],
    data: { animation: 'Telemetry', tabIndex: 0, backBtn: true },
  },
  {
    path: 'disabledassets/:id',
    component: DisabledAssetsComponent,
    canActivate: [authGuard],
    data: { animation: 'disabledassets', tabIndex: 0, backBtn: true },
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
